import { Advertising } from './advertisingBase'
import { AdParam } from './contanst'

export class AdPopUp extends Advertising {
  create () {
    // verifico si ya paso mas de X veces por esta seccion y muestro de nuevo el popUp
    const dateLast = window.sessionStorage.getItem('popup-' + this.data.id)
    if (!dateLast || (dateLast && Math.floor((new Date() - new Date(dateLast)) / 1000) > AdParam.intervalPopUp) || AdParam.development) {
      window.sessionStorage.setItem('popup-' + this.data.id, new Date())
    } else {
      return
    }
    if (this.data.notData) {
      return
    }
    this.init()
    this.container.querySelector('.pr-close').addEventListener('click', this.close)
    if (!AdParam.isDiagram) {
      this.createEvent()
      this.show()
    }
  }

  createEvent () {
    const container = document.getElementById('p-' + this.data.id)
    const items = container.querySelectorAll('.item')
    if (items.length > 1) {
      this.createCarousel()
    }
    this.addClick(items)
    this.addPrint(items)
  }

  close () {
    const container = document.getElementById('p-' + this.data.id)
    document.querySelector('body').classList.remove('modal-open')
    container.classList.add('hide')
    container.remove()
  }

  show () {
    const container = document.getElementById('p-' + this.data.id)
    if (container.querySelector('.pr-content article').innerHTML == '') {
      this.close()
    } else {
      document.querySelector('body').classList.add('modal-open')
      container.classList.remove('hide')
    }
  }
}
